// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Icon from "../../resources/images-and-icons/Icon.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Loyalty from "../../modules/Loyalty/Loyalty.res.js";
import * as Spinner from "../../resources/feedback-indicators/Spinner.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Customer from "../../modules/Customer/Customer.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as CanaryCard from "../../resources/layout-and-structure/CanaryCard.res.js";
import * as CopyButton from "../../resources/actions/CopyButton.res.js";
import * as CountBadge from "../../resources/feedback-indicators/CountBadge.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as SalesTable from "../../modules/Sale/SalesTable.res.js";
import * as TextAction from "../../resources/actions/TextAction.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as QueryString from "../../primitives/QueryString.res.js";
import * as SalesRoutes from "../Sales/SalesRoutes.res.js";
import * as TooltipIcon from "../../resources/overlays/TooltipIcon.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as CanarySurface from "../../resources/layout-and-structure/CanarySurface.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as StringHelpers from "../../helpers/StringHelpers.res.js";
import * as Client from "@apollo/client";
import * as AnimatedRender from "../../primitives/AnimatedRender.res.js";
import * as CustomerRoutes from "./CustomerRoutes.res.js";
import * as InputTextField from "../../resources/selection-and-input/InputTextField.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as CategoryTablist from "../../resources/navigation/CategoryTablist.res.js";
import * as Primitive_float from "@rescript/runtime/lib/es6/Primitive_float.js";
import * as CanaryDisclosure from "../../resources/data-visualizations/CanaryDisclosure.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CanaryCardInfoSwap from "../../resources/layout-and-structure/CanaryCardInfoSwap.res.js";
import * as CompanyLegalNumber from "../../modules/CompanyLegalNumber.res.js";
import * as InputTextAreaField from "../../resources/selection-and-input/InputTextAreaField.res.js";
import * as ElectronicInvoicing from "../../modules/ElectronicInvoicing/ElectronicInvoicing.res.js";
import * as Graphql_ppx_runtime from "@reasonml-community/graphql-ppx/rescript-runtime/graphql_ppx_runtime.res.js";
import * as CustomerArchiveModal from "../../modules/Customer/CustomerArchiveModal.res.js";
import * as CustomerLocationTile from "../../modules/Customer/CustomerLocationTile.res.js";
import * as CanaryInformationList from "../../resources/data-visualizations/CanaryInformationList.res.js";
import * as CanaryToolbarDocument from "../../resources/layout-and-structure/CanaryToolbarDocument.res.js";
import * as CustomerDetailsLoyalty from "../../modules/Customer/CustomerDetailsLoyalty.res.js";
import * as NextResourceDetailsPage from "../../core/NextResourceDetailsPage.res.js";
import * as CustomerAddressEditModal from "../../modules/Customer/CustomerAddressEditModal.res.js";
import * as CustomerCompanySuggestion from "../../modules/Customer/CustomerCompanySuggestion.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

function trimOptionalString(value) {
  return Stdlib_Option.flatMap(value, value => {
    let value$1 = value.trim();
    if (value$1 === "") {
      return;
    } else {
      return value$1;
    }
  });
}

function useEditRouterOptions() {
  let match = Navigation.useUrl();
  return Stdlib_Option.map(match.state, state => ({
    state: state
  }));
}

let Raw = {};

let query = Client.gql([
  "query CustomerDetailsQuery($customerId: ID!)  {\ncustomer(id: $customerId)  {\n__typename  \nid  \nshop  {\n__typename  \nid  \nname  \ncountry  \n}\n\nfirstName  \nlastName  \ncompanyName  \nkind  \ndateOfBirth  \nemail  \nphoneNumber  \nmobileNumber  \nprice  {\n__typename  \nid  \nname  \ntaxIncluded  \n}\n\nsiret  \nintraCommunityVAT  \ninvoicingEndpointId  \ninvoicingEndpointIdSchemeCode  \ninvoicingEndpointIdSchemeType  \nlocations  {\n__typename  \nid  \ncreatedAt  \narchivedAt  \nlabel  \nrecipient  \naddress  \npostalCode  \ncity  \ncountry  \ndefaults  \n}\n\ninternalCode  \nnote  \ncreatedAt  \nupdatedAt  \narchivedAt  \nunsubscribedFromLoyaltyProgramAt  \n...CustomerDetailsLoyaltyFragment   \n}\n\n}\n",
  ""
], CustomerDetailsLoyalty.CustomerDetailsLoyaltyFragment.query);

function parse(value) {
  let value$1 = value.customer;
  let value$2 = value$1["shop"];
  let value$3 = value$1["firstName"];
  let value$4 = value$1["lastName"];
  let value$5 = value$1["companyName"];
  let value$6 = value$1["kind"];
  let tmp;
  switch (value$6) {
    case "BUSINESS" :
      tmp = "BUSINESS";
      break;
    case "CONSUMER" :
      tmp = "CONSUMER";
      break;
    default:
      throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
  }
  let value$7 = value$1["dateOfBirth"];
  let value$8 = value$1["email"];
  let value$9 = value$1["phoneNumber"];
  let value$10 = value$1["mobileNumber"];
  let value$11 = value$1["price"];
  let value$12 = value$1["siret"];
  let value$13 = value$1["intraCommunityVAT"];
  let value$14 = value$1["invoicingEndpointId"];
  let value$15 = value$1["invoicingEndpointIdSchemeCode"];
  let value$16 = value$1["invoicingEndpointIdSchemeType"];
  let tmp$1;
  if (value$16 == null) {
    tmp$1 = undefined;
  } else {
    let tmp$2;
    switch (value$16) {
      case "BE_BCE" :
        tmp$2 = "BE_BCE";
        break;
      case "BE_TVA" :
        tmp$2 = "BE_TVA";
        break;
      case "FR_SIREN" :
        tmp$2 = "FR_SIREN";
        break;
      case "FR_SIREN_SIRET" :
        tmp$2 = "FR_SIREN_SIRET";
        break;
      case "FR_SIREN_SIRET_CODEROUTAGE" :
        tmp$2 = "FR_SIREN_SIRET_CODEROUTAGE";
        break;
      case "FR_SIREN_SUFFIX" :
        tmp$2 = "FR_SIREN_SUFFIX";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    tmp$1 = tmp$2;
  }
  let value$17 = value$1["locations"];
  let value$18 = value$1["internalCode"];
  let value$19 = value$1["note"];
  let value$20 = value$1["archivedAt"];
  let value$21 = value$1["unsubscribedFromLoyaltyProgramAt"];
  return {
    customer: {
      __typename: value$1["__typename"],
      id: value$1["id"],
      shop: {
        __typename: value$2.__typename,
        id: value$2.id,
        name: value$2.name,
        country: value$2.country
      },
      firstName: !(value$3 == null) ? value$3 : undefined,
      lastName: !(value$4 == null) ? value$4 : undefined,
      companyName: !(value$5 == null) ? value$5 : undefined,
      kind: tmp,
      dateOfBirth: !(value$7 == null) ? Scalar.Datetime.parse(value$7) : undefined,
      email: !(value$8 == null) ? value$8 : undefined,
      phoneNumber: !(value$9 == null) ? value$9 : undefined,
      mobileNumber: !(value$10 == null) ? value$10 : undefined,
      price: !(value$11 == null) ? ({
          __typename: value$11.__typename,
          id: value$11.id,
          name: value$11.name,
          taxIncluded: value$11.taxIncluded
        }) : undefined,
      siret: !(value$12 == null) ? value$12 : undefined,
      intraCommunityVAT: !(value$13 == null) ? value$13 : undefined,
      invoicingEndpointId: !(value$14 == null) ? value$14 : undefined,
      invoicingEndpointIdSchemeCode: !(value$15 == null) ? value$15 : undefined,
      invoicingEndpointIdSchemeType: tmp$1,
      locations: value$17.map(value => {
        let value$1 = value.archivedAt;
        let value$2 = value.recipient;
        let value$3 = value.address;
        let value$4 = value.postalCode;
        let value$5 = value.city;
        let value$6 = value.country;
        let value$7 = value.defaults;
        return {
          __typename: value.__typename,
          id: value.id,
          createdAt: Scalar.Datetime.parse(value.createdAt),
          archivedAt: !(value$1 == null) ? Scalar.Datetime.parse(value$1) : undefined,
          label: value.label,
          recipient: !(value$2 == null) ? value$2 : undefined,
          address: !(value$3 == null) ? value$3 : undefined,
          postalCode: !(value$4 == null) ? value$4 : undefined,
          city: !(value$5 == null) ? value$5 : undefined,
          country: !(value$6 == null) ? value$6 : undefined,
          defaults: value$7.map(value => {
            switch (value) {
              case "BILLING" :
                return "BILLING";
              case "DELIVERY" :
                return "DELIVERY";
              default:
                throw {
                  RE_EXN_ID: "Not_found",
                  Error: new Error()
                };
            }
          })
        };
      }),
      internalCode: !(value$18 == null) ? value$18 : undefined,
      note: !(value$19 == null) ? value$19 : undefined,
      createdAt: Scalar.Datetime.parse(value$1["createdAt"]),
      updatedAt: Scalar.Datetime.parse(value$1["updatedAt"]),
      archivedAt: !(value$20 == null) ? Scalar.Datetime.parse(value$20) : undefined,
      unsubscribedFromLoyaltyProgramAt: !(value$21 == null) ? Scalar.Datetime.parse(value$21) : undefined,
      customerDetailsLoyaltyFragment: CustomerDetailsLoyalty.CustomerDetailsLoyaltyFragment.verifyArgsAndParse("CustomerDetailsLoyaltyFragment", value$1)
    }
  };
}

function serialize(value) {
  let value$1 = value.customer;
  let value$2 = value$1.unsubscribedFromLoyaltyProgramAt;
  let unsubscribedFromLoyaltyProgramAt = value$2 !== undefined ? Scalar.Datetime.serialize(value$2) : null;
  let value$3 = value$1.archivedAt;
  let archivedAt = value$3 !== undefined ? Scalar.Datetime.serialize(value$3) : null;
  let value$4 = value$1.updatedAt;
  let value$5 = Scalar.Datetime.serialize(value$4);
  let value$6 = value$1.createdAt;
  let value$7 = Scalar.Datetime.serialize(value$6);
  let value$8 = value$1.note;
  let note = value$8 !== undefined ? value$8 : null;
  let value$9 = value$1.internalCode;
  let internalCode = value$9 !== undefined ? value$9 : null;
  let value$10 = value$1.locations;
  let locations = value$10.map(value => {
    let value$1 = value.defaults;
    let defaults = value$1.map(value => {
      if (value === "DELIVERY") {
        return "DELIVERY";
      } else {
        return "BILLING";
      }
    });
    let value$2 = value.country;
    let country = value$2 !== undefined ? value$2 : null;
    let value$3 = value.city;
    let city = value$3 !== undefined ? value$3 : null;
    let value$4 = value.postalCode;
    let postalCode = value$4 !== undefined ? value$4 : null;
    let value$5 = value.address;
    let address = value$5 !== undefined ? value$5 : null;
    let value$6 = value.recipient;
    let recipient = value$6 !== undefined ? value$6 : null;
    let value$7 = value.label;
    let value$8 = value.archivedAt;
    let archivedAt = value$8 !== undefined ? Scalar.Datetime.serialize(value$8) : null;
    let value$9 = value.createdAt;
    let value$10 = Scalar.Datetime.serialize(value$9);
    let value$11 = value.id;
    let value$12 = value.__typename;
    return {
      __typename: value$12,
      id: value$11,
      createdAt: value$10,
      archivedAt: archivedAt,
      label: value$7,
      recipient: recipient,
      address: address,
      postalCode: postalCode,
      city: city,
      country: country,
      defaults: defaults
    };
  });
  let value$11 = value$1.invoicingEndpointIdSchemeType;
  let invoicingEndpointIdSchemeType = value$11 !== undefined ? (
      value$11 === "BE_TVA" ? "BE_TVA" : (
          value$11 === "FR_SIREN" ? "FR_SIREN" : (
              value$11 === "FR_SIREN_SIRET_CODEROUTAGE" ? "FR_SIREN_SIRET_CODEROUTAGE" : (
                  value$11 === "FR_SIREN_SUFFIX" ? "FR_SIREN_SUFFIX" : (
                      value$11 === "FR_SIREN_SIRET" ? "FR_SIREN_SIRET" : "BE_BCE"
                    )
                )
            )
        )
    ) : null;
  let value$12 = value$1.invoicingEndpointIdSchemeCode;
  let invoicingEndpointIdSchemeCode = value$12 !== undefined ? value$12 : null;
  let value$13 = value$1.invoicingEndpointId;
  let invoicingEndpointId = value$13 !== undefined ? value$13 : null;
  let value$14 = value$1.intraCommunityVAT;
  let intraCommunityVAT = value$14 !== undefined ? value$14 : null;
  let value$15 = value$1.siret;
  let siret = value$15 !== undefined ? value$15 : null;
  let value$16 = value$1.price;
  let price;
  if (value$16 !== undefined) {
    let value$17 = value$16.taxIncluded;
    let value$18 = value$16.name;
    let value$19 = value$16.id;
    let value$20 = value$16.__typename;
    price = {
      __typename: value$20,
      id: value$19,
      name: value$18,
      taxIncluded: value$17
    };
  } else {
    price = null;
  }
  let value$21 = value$1.mobileNumber;
  let mobileNumber = value$21 !== undefined ? value$21 : null;
  let value$22 = value$1.phoneNumber;
  let phoneNumber = value$22 !== undefined ? value$22 : null;
  let value$23 = value$1.email;
  let email = value$23 !== undefined ? value$23 : null;
  let value$24 = value$1.dateOfBirth;
  let dateOfBirth = value$24 !== undefined ? Scalar.Datetime.serialize(value$24) : null;
  let value$25 = value$1.kind;
  let kind = value$25 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
  let value$26 = value$1.companyName;
  let companyName = value$26 !== undefined ? value$26 : null;
  let value$27 = value$1.lastName;
  let lastName = value$27 !== undefined ? value$27 : null;
  let value$28 = value$1.firstName;
  let firstName = value$28 !== undefined ? value$28 : null;
  let value$29 = value$1.shop;
  let value$30 = value$29.country;
  let value$31 = value$29.name;
  let value$32 = value$29.id;
  let value$33 = value$29.__typename;
  let shop = {
    __typename: value$33,
    id: value$32,
    name: value$31,
    country: value$30
  };
  let value$34 = value$1.id;
  let value$35 = value$1.__typename;
  let customer = Stdlib_Array.reduce([CustomerDetailsLoyalty.CustomerDetailsLoyaltyFragment.serialize(value$1.customerDetailsLoyaltyFragment)], {
    __typename: value$35,
    id: value$34,
    shop: shop,
    firstName: firstName,
    lastName: lastName,
    companyName: companyName,
    kind: kind,
    dateOfBirth: dateOfBirth,
    email: email,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    price: price,
    siret: siret,
    intraCommunityVAT: intraCommunityVAT,
    invoicingEndpointId: invoicingEndpointId,
    invoicingEndpointIdSchemeCode: invoicingEndpointIdSchemeCode,
    invoicingEndpointIdSchemeType: invoicingEndpointIdSchemeType,
    locations: locations,
    internalCode: internalCode,
    note: note,
    createdAt: value$7,
    updatedAt: value$5,
    archivedAt: archivedAt,
    unsubscribedFromLoyaltyProgramAt: unsubscribedFromLoyaltyProgramAt
  }, Graphql_ppx_runtime.deepMerge);
  return {
    customer: customer
  };
}

function serializeVariables(inp) {
  return {
    customerId: inp.customerId
  };
}

function makeVariables(customerId, param) {
  return {
    customerId: customerId
  };
}

let CustomerDetailsQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let CustomerDetailsQuery_refetchQueryDescription = include.refetchQueryDescription;

let CustomerDetailsQuery_useLazy = include.useLazy;

let CustomerDetailsQuery_useLazyWithVariables = include.useLazyWithVariables;

let CustomerDetailsQuery = {
  CustomerDetailsQuery_inner: CustomerDetailsQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: CustomerDetailsQuery_refetchQueryDescription,
  use: use,
  useLazy: CustomerDetailsQuery_useLazy,
  useLazyWithVariables: CustomerDetailsQuery_useLazyWithVariables
};

function make(param) {
  let customer = param.customer;
  let isBusiness = customer.kind === "BUSINESS";
  let loyalty = CustomerDetailsLoyalty.make(customer.customerDetailsLoyaltyFragment);
  return {
    id: customer.id,
    shop: {
      id: customer.shop.id,
      name: customer.shop.name,
      country: customer.shop.country
    },
    name: Stdlib_Option.getOr(Customer.makeName(customer.firstName, customer.lastName, customer.companyName), "?"),
    proName: isBusiness ? Customer.makeName(customer.firstName, customer.lastName, undefined) : undefined,
    firstName: customer.firstName,
    lastName: customer.lastName,
    companyName: customer.companyName,
    isBusiness: isBusiness,
    isLoyaltyMember: Stdlib_Option.isSome(loyalty),
    loyalty: loyalty,
    loyaltyUnsubscribedAt: customer.unsubscribedFromLoyaltyProgramAt,
    dateOfBirth: customer.dateOfBirth,
    email: customer.email,
    phoneNumber: customer.phoneNumber,
    mobileNumber: customer.mobileNumber,
    pricelist: Stdlib_Option.map(customer.price, price => ({
      id: price.id,
      name: price.name,
      taxIncluded: price.taxIncluded
    })),
    siret: customer.siret,
    intraCommunityVAT: customer.intraCommunityVAT,
    invoicingAddress: ElectronicInvoicing.InvoicingEndpoint.make(customer.invoicingEndpointIdSchemeType, customer.invoicingEndpointIdSchemeCode, customer.invoicingEndpointId),
    locations: customer.locations.filter(location => Stdlib_Option.isNone(location.archivedAt)).toSorted((current, next) => Primitive_float.compare(current.createdAt.getTime(), next.createdAt.getTime())).map(location => ({
      id: location.id,
      createdAt: location.createdAt,
      label: location.label,
      recipient: location.recipient,
      street: location.address,
      postalCode: location.postalCode,
      city: location.city,
      country: location.country,
      isBilling: location.defaults.some(value => value === "BILLING"),
      isDelivery: location.defaults.some(value => value === "DELIVERY")
    })),
    internalCode: customer.internalCode,
    note: customer.note,
    createdAt: customer.createdAt,
    updatedAt: customer.updatedAt,
    archivedAt: customer.archivedAt
  };
}

let CustomerDetailsData = {
  make: make
};

function formatPricelist(value) {
  return trimOptionalString(Stdlib_Option.map(value, param => {
    let taxLabel = param.taxIncluded ? I18n.t("VAT incl.") : I18n.t("VAT excl.");
    return param.name + ` - ` + taxLabel;
  }));
}

function useLoadingExceedsDelay(isLoading) {
  let match = React.useState(() => false);
  let setExceedsDelay = match[1];
  React.useEffect(() => {
    if (isLoading) {
      let handlerId = setTimeout(() => setExceedsDelay(param => true), 750);
      return () => {
        clearTimeout(handlerId);
      };
    }
    setExceedsDelay(param => false);
  }, [isLoading]);
  return match[0];
}

function totalCountValue(value) {
  if (typeof value !== "object") {
    return;
  } else {
    return Primitive_option.some(value._0);
  }
}

function subtitleElement(rows, totalCountResult) {
  let exit = 0;
  if (typeof rows !== "object") {
    exit = 1;
  } else if (rows.TAG === "Reloading") {
    if (rows._0.TAG !== "Ok") {
      return null;
    }
    exit = 1;
  } else {
    if (rows._0.TAG !== "Ok") {
      return null;
    }
    exit = 1;
  }
  if (exit === 1) {
    let exit$1 = 0;
    if (typeof totalCountResult !== "object") {
      return JsxRuntime.jsx(Spinner.make, {
        size: 16
      });
    }
    exit$1 = 2;
    if (exit$1 === 2) {
      let totalCount = totalCountResult._0;
      let formattedItemsCount = totalCount.toString().padStart(totalCount > 0 ? 2 : 1, "0");
      return JsxRuntime.jsx(CountBadge.make, {
        children: formattedItemsCount,
        size: "small",
        variation: "outline",
        tone: "neutral"
      });
    }
  }
}

function headerEndElement(saleType, customer, data) {
  let match = data.rows;
  if (typeof match !== "object") {
    return null;
  }
  match.TAG === "Reloading";
  let totalCount = totalCountValue(data.totalCount);
  if (totalCount === undefined) {
    return null;
  }
  if (totalCount <= 5) {
    return null;
  }
  let href = SalesRoutes.listRoute(saleType, customer.id, customer.name, customer.isBusiness, customer.shop.id);
  return JsxRuntime.jsx(CanaryCardInfoSwap.HeaderButton.make, {
    label: I18n.t("Show all"),
    icon: "see_ok",
    href: href
  });
}

function tableElement(saleType, filters, data, hiddenColumnKeys) {
  let tableView = JsxRuntime.jsx(SalesTable.SalesTableView.make, {
    saleType: saleType,
    filters: filters,
    data: data,
    hiddenColumnKeys: hiddenColumnKeys,
    compactPlaceholder: true
  });
  let match = data.rows;
  if (typeof match !== "object") {
    return null;
  }
  if (match.TAG === "Reloading") {
    if (match._0.TAG !== "Ok") {
      return tableView;
    }
  } else if (match._0.TAG !== "Ok") {
    return tableView;
  }
  let match$1 = totalCountValue(data.totalCount);
  if (match$1 !== undefined && match$1 !== 0) {
    return tableView;
  } else {
    return null;
  }
}

let make$1 = React.memo(props => {
  let saleType = props.saleType;
  let customer = props.customer;
  let filters = SalesTable.SalesTableQueryFilters.make(undefined, Primitive_option.some(customer.id), undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let data = SalesTable.SalesTableData.use(saleType, {
    first: 5
  }, filters, {
    TAG: "Date",
    _0: "descending"
  }, undefined, undefined);
  let match = data.totalCount;
  let loading;
  loading = typeof match !== "object" ? true : match.TAG !== "Done";
  let loadingExceedsDelay = useLoadingExceedsDelay(loading);
  let totalCount = data.totalCount;
  let isDimmed;
  isDimmed = typeof totalCount !== "object" ? !loadingExceedsDelay : (
      totalCount.TAG === "Done" ? totalCount._0 <= 0 : !loadingExceedsDelay
    );
  return JsxRuntime.jsx(CanarySurface.make, {
    tone: "neutral-ghost",
    opacity: isDimmed ? 0.55 : 1,
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [
          JsxRuntime.jsx(Box.make, {
            children: JsxRuntime.jsxs(Inline.make, {
              children: [
                JsxRuntime.jsxs(Inline.make, {
                  children: [
                    JsxRuntime.jsx(CanaryCard.Title.make, {
                      children: props.title
                    }),
                    JsxRuntime.jsx(CanarySeparator.make, {
                      size: "auto",
                      spacing: "s"
                    }),
                    subtitleElement(data.rows, data.totalCount)
                  ],
                  alignY: "center"
                }),
                headerEndElement(saleType, customer, data)
              ],
              align: "spaceBetween",
              alignY: "center"
            }),
            spaceX: "large"
          }),
          tableElement(saleType, filters, data, props.hiddenColumnKeys)
        ],
        space: "large"
      }),
      spaceY: "large"
    })
  });
});

let SaleDocumentSection = {
  loadingOpacityDelay: 750,
  useLoadingExceedsDelay: useLoadingExceedsDelay,
  totalCountValue: totalCountValue,
  subtitleElement: subtitleElement,
  headerEndElement: headerEndElement,
  tableElement: tableElement,
  make: make$1
};

function CustomerDetailsPage$CustomerDetailsSaleDocumentsTabview(props) {
  let customer = props.customer;
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      JsxRuntime.jsx(make$1, {
        customer: customer,
        title: I18n.t("Receipts"),
        saleType: "SalesReceipt",
        hiddenColumnKeys: ["customer"]
      }),
      JsxRuntime.jsx(make$1, {
        customer: customer,
        title: I18n.t("Invoices"),
        saleType: "Invoice",
        hiddenColumnKeys: ["customer"]
      }),
      JsxRuntime.jsx(make$1, {
        customer: customer,
        title: I18n.t("Delivery notes"),
        saleType: "DeliveryNote",
        hiddenColumnKeys: [
          "customer",
          "payment-method",
          "payment-date"
        ]
      }),
      JsxRuntime.jsx(make$1, {
        customer: customer,
        title: I18n.t("Quotes"),
        saleType: "Quote",
        hiddenColumnKeys: [
          "customer",
          "payment-method",
          "payment-date"
        ]
      }),
      JsxRuntime.jsx(make$1, {
        customer: customer,
        title: I18n.t("Credit notes"),
        saleType: "CreditNote",
        hiddenColumnKeys: [
          "customer",
          "status",
          "payment-method"
        ]
      }),
      JsxRuntime.jsx(make$1, {
        customer: customer,
        title: I18n.t("Refund receipts"),
        saleType: "RefundReceipt",
        hiddenColumnKeys: ["customer"]
      })
    ],
    space: "medium"
  });
}

let CustomerDetailsSaleDocumentsTabview = {
  tableRowLimit: 5,
  SaleDocumentSection: SaleDocumentSection,
  make: CustomerDetailsPage$CustomerDetailsSaleDocumentsTabview
};

let i18nPrefix = "customer_details_page.information_card.";

function formatEmail(value) {
  return Stdlib_Option.map(trimOptionalString(value), prim => prim.toLowerCase());
}

function formatPhoneNumber(value) {
  return Stdlib_Option.map(trimOptionalString(value), I18n.phoneNumberFormat);
}

function formatInvoicingAddress(value) {
  return trimOptionalString(ElectronicInvoicing.InvoicingEndpoint.formatOption(value));
}

function elapsedMonthsSince(createdAt) {
  let now = new Date();
  let elapsedMonths = (((now.getFullYear() - createdAt.getFullYear() | 0) * 12 | 0) + (now.getMonth() - createdAt.getMonth() | 0) | 0) - (
    now.getDate() < createdAt.getDate() ? 1 : 0
  ) | 0;
  return Math.max(elapsedMonths, 0);
}

function formatLabel(elapsedMonths) {
  let years = elapsedMonths / 12 | 0;
  let months = elapsedMonths % 12;
  let yearsLabel = I18n.t(I18n.isPlural(years) ? "years" : "year");
  let monthsLabel = I18n.t(I18n.isPlural(months) ? "months" : "month");
  if (years !== 0) {
    if (months !== 0) {
      return `+ ` + years.toString() + ` ` + yearsLabel;
    } else {
      return years.toString() + ` ` + yearsLabel;
    }
  } else if (months !== 0) {
    return months.toString() + ` ` + monthsLabel;
  } else {
    return I18n.t("New");
  }
}

let make$2 = React.memo(props => {
  let createdAt = props.createdAt;
  let elapsedMonths = elapsedMonthsSince(createdAt);
  let isNew = elapsedMonths === 0;
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx(Badge.make, {
      children: formatLabel(elapsedMonths),
      size: "normal",
      borderColor: isNew ? "#A9C5E7" : "#A2A1B0",
      backgroundColor: isNew ? "#F2F6FC" : "#E7E7EE",
      foregroundColor: isNew ? "#4F70C1" : "#25243A"
    }),
    placement: "top",
    content: JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.t("Tenure"),
          bold: true
        }),
        JsxRuntime.jsx(Tooltip.Gap.make, {
          space: "xxsmall"
        }),
        JsxRuntime.jsx(Tooltip.Span.make, {
          text: DateHelpers.formateToNumericDate(createdAt)
        })
      ]
    })
  });
});

let TenureBadge = {
  formatLabel: formatLabel,
  make: make$2
};

function CustomerDetailsPage$CustomerDetailsInformationCard$CustomerDetailsInformationCompanySuggestion(props) {
  let customer = props.customer;
  let billingLocation = Stdlib_Option.orElse(customer.locations.find(location => location.isBilling), customer.locations[0]);
  return JsxRuntime.jsx(CustomerCompanySuggestion.make, {
    criteria: {
      companyName: Stdlib_Option.getOr(customer.companyName, ""),
      directorFirstName: Stdlib_Option.getOr(customer.firstName, ""),
      directorLastName: Stdlib_Option.getOr(customer.lastName, ""),
      street: Stdlib_Option.getOr(Stdlib_Option.flatMap(billingLocation, location => location.street), ""),
      postalCode: Stdlib_Option.getOr(Stdlib_Option.flatMap(billingLocation, location => location.postalCode), ""),
      city: Stdlib_Option.getOr(Stdlib_Option.flatMap(billingLocation, location => location.city), "")
    },
    variant: {
      TAG: "Details",
      customerId: customer.id
    },
    skip: !customer.isBusiness || !CustomerCompanySuggestion.isCountryEligible(Stdlib_Option.getOr(Stdlib_Option.flatMap(billingLocation, location => location.country), ""), customer.shop.country)
  });
}

let CustomerDetailsInformationCompanySuggestion = {
  make: CustomerDetailsPage$CustomerDetailsInformationCard$CustomerDetailsInformationCompanySuggestion
};

let make$3 = React.memo(props => {
  let customer = props.customer;
  let editRouterOptions = useEditRouterOptions();
  let activeShop = Auth.useActiveShop();
  let isBelgianShop = ElectronicInvoicing.isShopFromBelgium(activeShop);
  let email = formatEmail(customer.email);
  let phoneNumber = Stdlib_Option.map(trimOptionalString(customer.phoneNumber), I18n.phoneNumberFormat);
  let mobileNumber = Stdlib_Option.map(trimOptionalString(customer.mobileNumber), I18n.phoneNumberFormat);
  let siret = trimOptionalString(customer.siret);
  let intraCommunityVAT = trimOptionalString(customer.intraCommunityVAT);
  let invoicingAddress = formatInvoicingAddress(customer.invoicingAddress);
  let proName = Stdlib_Option.map(customer.proName, prim => prim.trim());
  let tmp;
  tmp = proName !== undefined && proName !== "" ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(CanarySeparator.make, {
          size: "auto",
          spacing: "tiny"
        }),
        JsxRuntime.jsx(Title.make, {
          children: proName,
          level: 5,
          weight: "regular",
          color: "#767589"
        })
      ]
    }) : null;
  let dateOfBirth = customer.dateOfBirth;
  return JsxRuntime.jsxs(CanaryCardInfoSwap.make, {
    children: [
      JsxRuntime.jsxs(Stack.make, {
        children: [
          JsxRuntime.jsxs(Stack.make, {
            children: [
              JsxRuntime.jsx(CanaryDisclosure.make, {
                headerElement: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                  children: [
                    JsxRuntime.jsxs(Inline.make, {
                      children: [
                        JsxRuntime.jsx(Customer.Avatar.make, {
                          business: customer.isBusiness
                        }),
                        JsxRuntime.jsxs(Inline.make, {
                          children: [
                            JsxRuntime.jsx(Title.make, {
                              children: customer.name,
                              level: 4,
                              weight: "semibold"
                            }),
                            JsxRuntime.jsx(Box.make, {
                              spaceLeft: "xxsmall"
                            }),
                            JsxRuntime.jsx(CopyButton.Compact.make, {
                              value: customer.name,
                              size: 14
                            })
                          ]
                        })
                      ],
                      space: "small",
                      alignY: "center"
                    }),
                    tmp
                  ]
                }),
                headerEndElement: JsxRuntime.jsx(Customer.Badge.make, {
                  business: customer.isBusiness,
                  loyaltyProgramMember: customer.isLoyaltyMember
                })
              }),
              JsxRuntime.jsx(CanaryDisclosure.make, {
                headerElement: dateOfBirth !== undefined ? JsxRuntime.jsxs(Inline.make, {
                    children: [
                      JsxRuntime.jsx(Title.make, {
                        children: DateHelpers.formateToNumericDate(dateOfBirth) + ` - ` + Customer.formatAge(dateOfBirth),
                        level: 5,
                        weight: "regular",
                        color: "#767589"
                      }),
                      Customer.isBirthdaySoon(dateOfBirth) ? JsxRuntime.jsx(Icon.make, {
                          name: "cake",
                          fill: "#25243A",
                          width: 14,
                          height: 14
                        }) : null
                    ],
                    space: "xsmall",
                    alignY: "center"
                  }) : JsxRuntime.jsx(Title.make, {
                    children: customer.isBusiness ? I18n.t("Customer tenure") : I18n.t("Age not provided"),
                    level: 5,
                    weight: customer.isBusiness ? "semibold" : "regular",
                    italic: !customer.isBusiness,
                    color: "#767589"
                  }),
                headerEndElement: JsxRuntime.jsx(make$2, {
                  createdAt: customer.createdAt
                }),
                hideTopSeparator: true
              })
            ],
            space: "none"
          }),
          JsxRuntime.jsxs(CanaryInformationList.make, {
            title: I18n.t("Contact details"),
            children: [
              JsxRuntime.jsx(CanaryInformationList.Line.make, {
                label: I18n.t("Email"),
                value: email
              }),
              JsxRuntime.jsx(CanaryInformationList.Line.make, {
                label: I18n.t("Phone"),
                value: phoneNumber
              }),
              JsxRuntime.jsx(CanaryInformationList.Line.make, {
                label: I18n.t("Mobile"),
                value: mobileNumber
              })
            ]
          }),
          customer.isBusiness ? JsxRuntime.jsxs(CanaryInformationList.make, {
              title: I18n.t("Invoicing"),
              children: [
                isBelgianShop ? null : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsx(CanaryInformationList.Line.make, {
                        label: I18n.t(i18nPrefix + "list_line.siret.label"),
                        value: Stdlib_Option.map(siret, CompanyLegalNumber.French.format),
                        href: Stdlib_Option.map(siret, siret => CompanyLegalNumber.French.registryUrl(siret))
                      }),
                      JsxRuntime.jsx(CanaryInformationList.Line.make, {
                        label: I18n.t(i18nPrefix + "list_line.siren.label"),
                        value: Stdlib_Option.map(siret, siret => CompanyLegalNumber.French.format(CompanyLegalNumber.French.sirenFromSiret(siret)))
                      })
                    ]
                  }),
                JsxRuntime.jsx(CanaryInformationList.Line.make, {
                  label: I18n.t("Intracommunity VAT"),
                  value: intraCommunityVAT
                }),
                JsxRuntime.jsx(CanaryInformationList.Line.make, {
                  label: I18n.t("Elec. invoicing address"),
                  value: invoicingAddress
                })
              ]
            }) : null
        ],
        space: "large"
      }),
      Stdlib_Option.isNone(siret) ? JsxRuntime.jsx(CustomerDetailsPage$CustomerDetailsInformationCard$CustomerDetailsInformationCompanySuggestion, {
          customer: customer
        }) : null
    ],
    title: I18n.t("General information"),
    headerEndElement: JsxRuntime.jsx(CanaryCardInfoSwap.HeaderButton.make, {
      tooltipText: I18n.t("Edit"),
      icon: "edit",
      href: CustomerRoutes.editRoute(customer.id, undefined),
      routerOptions: editRouterOptions
    })
  });
});

let CustomerDetailsInformationCard = {
  i18nPrefix: i18nPrefix,
  formatEmail: formatEmail,
  formatPhoneNumber: formatPhoneNumber,
  formatInvoicingAddress: formatInvoicingAddress,
  elapsedMonthsSince: elapsedMonthsSince,
  TenureBadge: TenureBadge,
  CustomerDetailsInformationCompanySuggestion: CustomerDetailsInformationCompanySuggestion,
  make: make$3
};

function formatPoints(points) {
  return points.toString() + (
    points > 1 ? " points" : " point"
  );
}

function CustomerDetailsPage$CustomerDetailsLoyaltyCard(props) {
  let customer = props.customer;
  let match = React.useState(() => {});
  let setOpenedModal = match[1];
  let openedModal = match[0];
  let onRequestCloseModal = () => setOpenedModal(param => {});
  let match$1 = Hover.use(undefined, true, undefined);
  let match$2 = customer.loyalty;
  let tmp;
  if (match$2 !== undefined) {
    let hasEligibleReward = match$2.eligibleRewards.length !== 0;
    tmp = JsxRuntime.jsx(CanaryToolbarDocument.make, {
      title: formatPoints(match$2.stats.availablePoints),
      comment: hasEligibleReward ? I18n.t("Eligible reward") : undefined,
      commentColor: hasEligibleReward ? "#A01E72" : undefined,
      actionElements: JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx(AnimatedRender.make, {
            children: JsxRuntime.jsxs(Inline.make, {
              children: [
                JsxRuntime.jsx(Button.make, {
                  variant: {
                    NAME: "ghost",
                    VAL: {
                      bordered: true
                    }
                  },
                  tone: "danger",
                  size: "small",
                  bold: true,
                  icon: "cross",
                  tooltipText: I18n.t("Unsubscribe the customer"),
                  onPress: () => setOpenedModal(param => "Unsubscribe")
                }),
                JsxRuntime.jsx(Button.make, {
                  variant: {
                    NAME: "ghost",
                    VAL: {
                      bordered: true
                    }
                  },
                  size: "small",
                  bold: true,
                  icon: "edit",
                  tooltipText: I18n.t("Change the number of points"),
                  onPress: () => setOpenedModal(param => "PointsEdit")
                }),
                JsxRuntime.jsx(CanarySeparator.make, {
                  orientation: "vertical",
                  size: "medium",
                  spacing: "xs"
                })
              ],
              space: "small",
              alignY: "center"
            }),
            displayed: match$1[1],
            animation: "fade"
          }),
          JsxRuntime.jsx(Button.make, {
            size: "small",
            bold: true,
            icon: "see_ok",
            statusLight: hasEligibleReward,
            tooltipText: I18n.t("customer_details_page.loyalty_card.see_loyalty_tooltip"),
            onPress: props.onRequestOpenLoyaltyTab
          })
        ]
      })
    });
  } else {
    let unsubscribedAt = customer.loyaltyUnsubscribedAt;
    tmp = JsxRuntime.jsx(CanarySurface.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsx(Title.make, {
              children: I18n.t("Not a member yet"),
              level: 4,
              align: "center",
              weight: "medium",
              color: "#25243A"
            }),
            unsubscribedAt !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                children: I18n.template(I18n.t("Unsubscribed on {{date}}"), {
                  date: DateHelpers.formateToNumericDate(unsubscribedAt)
                }, undefined),
                align: "center",
                variation: "neutral",
                size: "small"
              }) : null,
            JsxRuntime.jsx(Box.make, {
              children: JsxRuntime.jsx(Inline.make, {
                children: JsxRuntime.jsx(TextAction.make, {
                  text: I18n.t("customer_details_page.loyalty_card.subscribe_text_action"),
                  size: "compact",
                  highlighted: true,
                  trailingIcon: "none",
                  onPress: props.onRequestSubscribe
                }),
                align: "center"
              }),
              spaceTop: "xxsmall"
            })
          ],
          space: "xxsmall"
        }),
        spaceX: "large",
        spaceY: "xlarge"
      })
    });
  }
  let match$3 = customer.loyalty;
  let match$4 = customer.loyalty;
  let tmp$1;
  if (match$4 !== undefined) {
    let subscribedAt = match$4.subscribedAt;
    tmp$1 = subscribedAt !== undefined ? JsxRuntime.jsx(Title.make, {
        children: DateHelpers.formateToNumericDate(subscribedAt),
        level: 5,
        weight: "regular",
        color: "#767589"
      }) : null;
  } else {
    tmp$1 = null;
  }
  return JsxRuntime.jsxs(CanaryCardInfoSwap.make, {
    children: [
      JsxRuntime.jsx("div", {
        children: tmp,
        ref: Primitive_option.some(match$1[0])
      }),
      match$3 !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(CustomerDetailsLoyalty.LoyaltyUnsubscribeModal.make, {
              customerId: customer.id,
              opened: openedModal === "Unsubscribe",
              onRequestClose: onRequestCloseModal
            }),
            JsxRuntime.jsx(CustomerDetailsLoyalty.LoyaltyPointsEditModal.make, {
              customerId: customer.id,
              shopId: customer.shop.id,
              currentPoints: match$3.stats.availablePoints,
              opened: openedModal === "PointsEdit",
              onRequestClose: onRequestCloseModal
            })
          ]
        }) : null
    ],
    title: I18n.t("Loyalty"),
    headerElement: tmp$1
  });
}

let CustomerDetailsLoyaltyCard = {
  formatPoints: formatPoints,
  make: CustomerDetailsPage$CustomerDetailsLoyaltyCard
};

let Raw$1 = {};

let query$1 = Client.gql(["mutation CustomerDetailsUpdateLocationsMutation($id: ID!, $customerInput: InputUpdateCustomerTypeDef, $locationsInput: [InputCreateOrUpdateCustomerLocationTypeDef!])  {\nupdateCustomer(id: $id, customerInput: $customerInput, locationsInput: $locationsInput)  {\n__typename  \nid  \nlocations  {\n__typename  \nid  \ncreatedAt  \narchivedAt  \nlabel  \nrecipient  \naddress  \npostalCode  \ncity  \ncountry  \ndefaults  \n}\n\n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.updateCustomer;
  let value$2 = value$1.locations;
  return {
    updateCustomer: {
      __typename: value$1.__typename,
      id: value$1.id,
      locations: value$2.map(value => {
        let value$1 = value.archivedAt;
        let value$2 = value.recipient;
        let value$3 = value.address;
        let value$4 = value.postalCode;
        let value$5 = value.city;
        let value$6 = value.country;
        let value$7 = value.defaults;
        return {
          __typename: value.__typename,
          id: value.id,
          createdAt: Scalar.Datetime.parse(value.createdAt),
          archivedAt: !(value$1 == null) ? Scalar.Datetime.parse(value$1) : undefined,
          label: value.label,
          recipient: !(value$2 == null) ? value$2 : undefined,
          address: !(value$3 == null) ? value$3 : undefined,
          postalCode: !(value$4 == null) ? value$4 : undefined,
          city: !(value$5 == null) ? value$5 : undefined,
          country: !(value$6 == null) ? value$6 : undefined,
          defaults: value$7.map(value => {
            switch (value) {
              case "BILLING" :
                return "BILLING";
              case "DELIVERY" :
                return "DELIVERY";
              default:
                throw {
                  RE_EXN_ID: "Not_found",
                  Error: new Error()
                };
            }
          })
        };
      })
    }
  };
}

function serialize$1(value) {
  let value$1 = value.updateCustomer;
  let value$2 = value$1.locations;
  let locations = value$2.map(value => {
    let value$1 = value.defaults;
    let defaults = value$1.map(value => {
      if (value === "DELIVERY") {
        return "DELIVERY";
      } else {
        return "BILLING";
      }
    });
    let value$2 = value.country;
    let country = value$2 !== undefined ? value$2 : null;
    let value$3 = value.city;
    let city = value$3 !== undefined ? value$3 : null;
    let value$4 = value.postalCode;
    let postalCode = value$4 !== undefined ? value$4 : null;
    let value$5 = value.address;
    let address = value$5 !== undefined ? value$5 : null;
    let value$6 = value.recipient;
    let recipient = value$6 !== undefined ? value$6 : null;
    let value$7 = value.label;
    let value$8 = value.archivedAt;
    let archivedAt = value$8 !== undefined ? Scalar.Datetime.serialize(value$8) : null;
    let value$9 = value.createdAt;
    let value$10 = Scalar.Datetime.serialize(value$9);
    let value$11 = value.id;
    let value$12 = value.__typename;
    return {
      __typename: value$12,
      id: value$11,
      createdAt: value$10,
      archivedAt: archivedAt,
      label: value$7,
      recipient: recipient,
      address: address,
      postalCode: postalCode,
      city: city,
      country: country,
      defaults: defaults
    };
  });
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let updateCustomer = {
    __typename: value$4,
    id: value$3,
    locations: locations
  };
  return {
    updateCustomer: updateCustomer
  };
}

function serializeInputObjectInputCreateOrUpdateCustomerLocationTypeDef(inp) {
  let a = inp.id;
  let a$1 = inp.defaults;
  let a$2 = inp.recipient;
  let a$3 = inp.address;
  let a$4 = inp.postalCode;
  let a$5 = inp.city;
  let a$6 = inp.country;
  return {
    id: a !== undefined ? a : undefined,
    label: inp.label,
    defaults: a$1.map(b => {
      if (b === "DELIVERY") {
        return "DELIVERY";
      } else {
        return "BILLING";
      }
    }),
    recipient: a$2 !== undefined ? a$2 : undefined,
    address: a$3 !== undefined ? a$3 : undefined,
    postalCode: a$4 !== undefined ? a$4 : undefined,
    city: a$5 !== undefined ? a$5 : undefined,
    country: a$6 !== undefined ? a$6 : undefined
  };
}

function serializeInputObjectInputUpdateCustomerTypeDef(inp) {
  let a = inp.priceId;
  let a$1 = inp.companyName;
  let a$2 = inp.intraCommunityVAT;
  let a$3 = inp.firstName;
  let a$4 = inp.lastName;
  let a$5 = inp.email;
  let a$6 = inp.phoneNumber;
  let a$7 = inp.mobileNumber;
  let a$8 = inp.note;
  let a$9 = inp.siret;
  let a$10 = inp.internalCode;
  let a$11 = inp.invoicingEndpointId;
  let a$12 = inp.invoicingEndpointIdSchemeCode;
  let a$13 = inp.invoicingEndpointIdSchemeType;
  let a$14 = inp.dateOfBirth;
  return {
    priceId: a !== undefined ? a : undefined,
    companyName: a$1 !== undefined ? a$1 : undefined,
    intraCommunityVAT: a$2 !== undefined ? a$2 : undefined,
    firstName: a$3 !== undefined ? a$3 : undefined,
    lastName: a$4 !== undefined ? a$4 : undefined,
    email: a$5 !== undefined ? a$5 : undefined,
    phoneNumber: a$6 !== undefined ? a$6 : undefined,
    mobileNumber: a$7 !== undefined ? a$7 : undefined,
    note: a$8 !== undefined ? a$8 : undefined,
    siret: a$9 !== undefined ? a$9 : undefined,
    internalCode: a$10 !== undefined ? a$10 : undefined,
    invoicingEndpointId: a$11 !== undefined ? a$11 : undefined,
    invoicingEndpointIdSchemeCode: a$12 !== undefined ? a$12 : undefined,
    invoicingEndpointIdSchemeType: a$13 !== undefined ? (
        a$13 === "BE_TVA" ? "BE_TVA" : (
            a$13 === "FR_SIREN" ? "FR_SIREN" : (
                a$13 === "FR_SIREN_SIRET_CODEROUTAGE" ? "FR_SIREN_SIRET_CODEROUTAGE" : (
                    a$13 === "FR_SIREN_SUFFIX" ? "FR_SIREN_SUFFIX" : (
                        a$13 === "FR_SIREN_SIRET" ? "FR_SIREN_SIRET" : "BE_BCE"
                      )
                  )
              )
          )
      ) : undefined,
    dateOfBirth: a$14 !== undefined ? a$14 : undefined
  };
}

function serializeVariables$1(inp) {
  let a = inp.customerInput;
  let a$1 = inp.locationsInput;
  return {
    id: inp.id,
    customerInput: a !== undefined ? serializeInputObjectInputUpdateCustomerTypeDef(a) : undefined,
    locationsInput: a$1 !== undefined ? a$1.map(serializeInputObjectInputCreateOrUpdateCustomerLocationTypeDef) : undefined
  };
}

function makeVariables$1(id, customerInput, locationsInput, param) {
  return {
    id: id,
    customerInput: customerInput,
    locationsInput: locationsInput
  };
}

function makeInputObjectInputUpdateCustomerTypeDef(priceId, companyName, intraCommunityVAT, firstName, lastName, email, phoneNumber, mobileNumber, note, siret, internalCode, invoicingEndpointId, invoicingEndpointIdSchemeCode, invoicingEndpointIdSchemeType, dateOfBirth, param) {
  return {
    priceId: priceId,
    companyName: companyName,
    intraCommunityVAT: intraCommunityVAT,
    firstName: firstName,
    lastName: lastName,
    email: email,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    note: note,
    siret: siret,
    internalCode: internalCode,
    invoicingEndpointId: invoicingEndpointId,
    invoicingEndpointIdSchemeCode: invoicingEndpointIdSchemeCode,
    invoicingEndpointIdSchemeType: invoicingEndpointIdSchemeType,
    dateOfBirth: dateOfBirth
  };
}

function makeInputObjectInputCreateOrUpdateCustomerLocationTypeDef(id, label, defaults, recipient, address, postalCode, city, country, param) {
  return {
    id: id,
    label: label,
    defaults: defaults,
    recipient: recipient,
    address: address,
    postalCode: postalCode,
    city: city,
    country: country
  };
}

let UpdateLocationsMutation_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateCustomerTypeDef: serializeInputObjectInputUpdateCustomerTypeDef,
  serializeInputObjectInputCreateOrUpdateCustomerLocationTypeDef: serializeInputObjectInputCreateOrUpdateCustomerLocationTypeDef,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateCustomerTypeDef: makeInputObjectInputUpdateCustomerTypeDef,
  makeInputObjectInputCreateOrUpdateCustomerLocationTypeDef: makeInputObjectInputCreateOrUpdateCustomerLocationTypeDef
};

let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let UpdateLocationsMutation_useWithVariables = include$1.useWithVariables;

let UpdateLocationsMutation = {
  UpdateLocationsMutation_inner: UpdateLocationsMutation_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateCustomerTypeDef: serializeInputObjectInputUpdateCustomerTypeDef,
  serializeInputObjectInputCreateOrUpdateCustomerLocationTypeDef: serializeInputObjectInputCreateOrUpdateCustomerLocationTypeDef,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateCustomerTypeDef: makeInputObjectInputUpdateCustomerTypeDef,
  makeInputObjectInputCreateOrUpdateCustomerLocationTypeDef: makeInputObjectInputCreateOrUpdateCustomerLocationTypeDef,
  use: use$1,
  useWithVariables: UpdateLocationsMutation_useWithVariables
};

function addressFromLocation(location) {
  return {
    id: location.id,
    key: location.id,
    label: location.label,
    recipient: Stdlib_Option.getOr(location.recipient, ""),
    street: Stdlib_Option.getOr(location.street, ""),
    postalCode: Stdlib_Option.getOr(location.postalCode, ""),
    city: Stdlib_Option.getOr(location.city, ""),
    country: Stdlib_Option.getOr(location.country, ""),
    isBilling: location.isBilling,
    isDelivery: location.isDelivery
  };
}

function customerInputFromCustomer(customer) {
  return makeInputObjectInputUpdateCustomerTypeDef(Stdlib_Option.map(customer.pricelist, param => param.id), customer.companyName, customer.intraCommunityVAT, customer.firstName, customer.lastName, customer.email, customer.phoneNumber, customer.mobileNumber, customer.note, customer.siret, customer.internalCode, Stdlib_Option.map(customer.invoicingAddress, param => param.endpointId), Stdlib_Option.map(customer.invoicingAddress, param => param.schemeCode), Stdlib_Option.flatMap(customer.invoicingAddress, param => param.schemeType), Stdlib_Option.map(customer.dateOfBirth, Scalar.Datetime.serialize), undefined);
}

function locationInputFromAddress(address) {
  return makeInputObjectInputCreateOrUpdateCustomerLocationTypeDef(address.id, address.label, CustomerAddressEditModal.defaults(address), StringHelpers.stripEmptyString(address.recipient), StringHelpers.stripEmptyString(address.street), StringHelpers.stripEmptyString(address.postalCode), StringHelpers.stripEmptyString(address.city), StringHelpers.stripEmptyString(address.country), undefined);
}

function formatLocation(location) {
  return Stdlib_Array.filterMap([
    location.street,
    CustomerLocationTile.formatPostalCityLine(location.postalCode, location.city)
  ], trimOptionalString).join("\n");
}

function CustomerDetailsPage$CustomerDetailsAddressesCard$LocationCopyButton(props) {
  let match = CopyButton.use(formatLocation(props.location), undefined);
  let copied = match.copied;
  return JsxRuntime.jsx(Button.make, {
    ariaProps: match.ariaProps,
    tone: {
      NAME: "neutral",
      VAL: {
        quiet: !copied
      }
    },
    size: "small",
    bold: copied,
    icon: match.icon,
    tooltipText: match.tooltipText,
    onPress: match.copy
  });
}

let LocationCopyButton = {
  formatLocation: formatLocation,
  make: CustomerDetailsPage$CustomerDetailsAddressesCard$LocationCopyButton
};

function CustomerDetailsPage$CustomerDetailsAddressesCard(props) {
  let customer = props.customer;
  let editRouterOptions = useEditRouterOptions();
  let match = React.useState(() => {});
  let setEdited = match[1];
  let edited = match[0];
  let match$1 = React.useState(() => {});
  let setErrorMessage = match$1[1];
  let match$2 = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let updateLocations = match$2[0];
  let match$3 = Hover.use(undefined, true, undefined);
  let hovered = match$3[1];
  let onCommit = address => Future.tapError(Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(updateLocations(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    id: customer.id,
    customerInput: customerInputFromCustomer(customer),
    locationsInput: CustomerAddressEditModal.withExclusiveBilling(customer.locations.map(location => {
      if (location.id === address.key) {
        return address;
      } else {
        return addressFromLocation(location);
      }
    }), address).map(locationInputFromAddress)
  })), undefined, param => {}), error => setErrorMessage(param => error));
  return JsxRuntime.jsx(CanaryCardInfoSwap.make, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(Stack.make, {
          children: customer.locations.length === 0 ? JsxRuntime.jsx(CanarySurface.make, {
              children: JsxRuntime.jsx(Box.make, {
                children: JsxRuntime.jsx(Title.make, {
                  children: I18n.t("No specified address"),
                  level: 4,
                  align: "center",
                  weight: "medium",
                  color: "#25243A"
                }),
                spaceX: "large",
                spaceY: "xlarge"
              })
            }) : customer.locations.map(location => JsxRuntime.jsx(CustomerLocationTile.make, {
              label: location.label,
              recipient: location.recipient,
              street: location.street,
              postalCode: location.postalCode,
              city: location.city,
              country: location.country,
              isBilling: location.isBilling,
              isDelivery: location.isDelivery,
              endActionsElement: JsxRuntime.jsx(Inline.make, {
                children: JsxRuntime.jsx(AnimatedRender.make, {
                  children: JsxRuntime.jsxs(Inline.make, {
                    children: [
                      JsxRuntime.jsx(CustomerDetailsPage$CustomerDetailsAddressesCard$LocationCopyButton, {
                        location: location
                      }),
                      JsxRuntime.jsx(Button.make, {
                        tone: {
                          NAME: "neutral",
                          VAL: {
                            quiet: true
                          }
                        },
                        size: "small",
                        icon: "edit",
                        tooltipText: I18n.t("Edit"),
                        onPress: () => {
                          setErrorMessage(param => {});
                          setEdited(param => addressFromLocation(location));
                        }
                      })
                    ],
                    space: "small"
                  }),
                  displayed: hovered,
                  animation: "fade"
                }),
                align: "end",
                alignY: "top",
                grow: true,
                fullWidth: true
              })
            }, location.id)),
          space: "medium"
        }),
        JsxRuntime.jsx(CustomerAddressEditModal.make, {
          value: edited,
          hasOtherBillingAddress: customer.locations.some(location => {
            if (location.isBilling) {
              return Stdlib_Option.mapOr(edited, true, param => param.key !== location.id);
            } else {
              return false;
            }
          }),
          errorMessage: match$1[0],
          onCommit: onCommit,
          onRequestClose: () => setEdited(param => {})
        })
      ],
      ref: Primitive_option.some(match$3[0])
    }),
    title: I18n.t("Addresses"),
    headerEndElement: JsxRuntime.jsx(CanaryCardInfoSwap.HeaderButton.make, {
      tooltipText: I18n.t("Edit"),
      icon: "edit",
      href: CustomerRoutes.editSectionRoute(customer.id, "Addresses"),
      routerOptions: editRouterOptions
    })
  });
}

let CustomerDetailsAddressesCard = {
  UpdateLocationsMutation: UpdateLocationsMutation,
  addressFromLocation: addressFromLocation,
  customerInputFromCustomer: customerInputFromCustomer,
  locationInputFromAddress: locationInputFromAddress,
  LocationCopyButton: LocationCopyButton,
  make: CustomerDetailsPage$CustomerDetailsAddressesCard
};

function CustomerDetailsPage$CustomerDetailsMiscCard(props) {
  let customer = props.customer;
  let editRouterOptions = useEditRouterOptions();
  let scope = Auth.useScope();
  let pricelist = formatPricelist(customer.pricelist);
  let tmp;
  tmp = scope.TAG === "Organisation" ? JsxRuntime.jsx(CanaryInformationList.Line.make, {
      label: I18n.t("Shop"),
      valueElement: JsxRuntime.jsx(CanaryInformationList.ValueBadge.make, {
        value: customer.shop.name,
        backgroundColor: "rgba(255, 255, 255, 1)"
      }),
      hideCopyButton: true
    }) : null;
  return JsxRuntime.jsx(CanaryCardInfoSwap.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsxs(CanaryInformationList.make, {
            children: [
              tmp,
              JsxRuntime.jsx(CanaryInformationList.Line.make, {
                label: I18n.t("Price list"),
                valueElement: Stdlib_Option.map(pricelist, value => JsxRuntime.jsx(CanaryInformationList.ValueBadge.make, {
                  value: value
                })),
                hideCopyButton: true
              })
            ]
          }),
          spaceTop: "xsmall"
        }),
        JsxRuntime.jsx(InputTextField.make, {
          label: I18n.t("Internal code"),
          disabled: true,
          placeholder: Placeholder.NC.text,
          value: Stdlib_Option.getOr(customer.internalCode, "")
        }),
        JsxRuntime.jsx(InputTextAreaField.make, {
          label: I18n.t("Internal memo"),
          disabled: true,
          placeholder: I18n.t("No memo"),
          value: Stdlib_Option.getOr(customer.note, "")
        })
      ],
      space: "large"
    }),
    title: I18n.t("Misc"),
    headerEndElement: JsxRuntime.jsx(CanaryCardInfoSwap.HeaderButton.make, {
      tooltipText: I18n.t("Edit"),
      icon: "edit",
      href: CustomerRoutes.editSectionRoute(customer.id, "Misc"),
      routerOptions: editRouterOptions
    })
  });
}

let CustomerDetailsMiscCard = {
  make: CustomerDetailsPage$CustomerDetailsMiscCard
};

let make$4 = React.memo(props => {
  let value = props.value;
  let ref = React.useRef(null);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs(Inline.make, {
      children: [
        JsxRuntime.jsx(TextStyle.make, {
          children: props.label,
          weight: "semibold",
          size: "small",
          lineHeight: "medium",
          wrap: false
        }),
        value !== undefined ? JsxRuntime.jsxs(Inline.make, {
            children: [
              JsxRuntime.jsx(TextStyle.make, {
                children: value,
                align: "end",
                variation: "neutral",
                size: "small",
                lineHeight: "medium",
                wrap: false
              }),
              Stdlib_Option.mapOr(props.tooltipText, null, tooltipText => JsxRuntime.jsx(TooltipIcon.make, {
                children: JsxRuntime.jsx(Tooltip.Span.make, {
                  text: tooltipText
                }),
                variation: "quiet_info",
                altTriggerRef: ref,
                iconSize: 15
              }))
            ],
            space: "small",
            align: "end"
          }) : JsxRuntime.jsx(Offset.make, {
            children: JsxRuntime.jsx(Placeholder.Empty.make, {}),
            right: 24,
            bottom: 0,
            width: 16,
            height: 16
          })
      ],
      space: "small",
      align: "spaceBetween"
    }),
    ref: Primitive_option.some(ref)
  });
});

let MetadataInformationDetailRow = {
  make: make$4
};

function CustomerDetailsPage$CustomerDetailsMetadataCard(props) {
  let customer = props.customer;
  let formattedCreatedAtDate = DateHelpers.formateToMediumDate(customer.createdAt);
  let formattedCreatedAtTime = DateHelpers.formateToShortTime(undefined, customer.createdAt);
  let formattedUpdatedAtDate = customer.updatedAt.getTime() === customer.createdAt.getTime() ? undefined : DateHelpers.formateToMediumDate(customer.updatedAt);
  let formattedUpdatedAtTime = DateHelpers.formateToShortTime(undefined, customer.updatedAt);
  let formattedArchivedAtDate = Stdlib_Option.map(customer.archivedAt, DateHelpers.formateToMediumDate);
  let formattedArchivedAtTime = Stdlib_Option.map(customer.archivedAt, date => DateHelpers.formateToShortTime(undefined, date));
  return JsxRuntime.jsx(CanaryCardInfoSwap.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(make$4, {
          label: I18n.t("Creation"),
          value: formattedCreatedAtDate,
          tooltipText: formattedCreatedAtTime
        }),
        JsxRuntime.jsx(make$4, {
          label: I18n.t("Modification"),
          value: formattedUpdatedAtDate,
          tooltipText: formattedUpdatedAtTime
        }),
        JsxRuntime.jsx(make$4, {
          label: I18n.t("Archiving"),
          value: formattedArchivedAtDate,
          tooltipText: formattedArchivedAtTime
        })
      ],
      space: "small"
    }),
    title: I18n.t("Metadata")
  });
}

let CustomerDetailsMetadataCard = {
  MetadataInformationDetailRow: MetadataInformationDetailRow,
  make: CustomerDetailsPage$CustomerDetailsMetadataCard
};

let make$5 = React.memo(props => {
  let status = props.status;
  let id = props.id;
  let editRouterOptions = useEditRouterOptions();
  let match = React.useState(() => false);
  let setArchiveModalOpened = match[1];
  let tmp;
  tmp = status === "Active" ? JsxRuntime.jsx(Button.make, {
      label: I18n.t("Archive"),
      tone: "danger",
      icon: "archive",
      onPress: () => setArchiveModalOpened(param => true)
    }) : JsxRuntime.jsx(Button.make, {
      label: I18n.t("Unarchive"),
      tone: "brand",
      icon: "unarchive",
      onPress: () => setArchiveModalOpened(param => true)
    });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Button.make, {
        label: I18n.t("Edit"),
        icon: "edit",
        href: CustomerRoutes.editRoute(id, undefined),
        routerOptions: editRouterOptions
      }),
      tmp,
      JsxRuntime.jsx(CustomerArchiveModal.make, {
        id: id,
        status: status,
        opened: match[0],
        onRequestClose: () => setArchiveModalOpened(param => false)
      })
    ]
  });
});

let CustomerDetailsPageActions = {
  make: make$5
};

let values = [
  "Documents",
  "Loyalty"
];

function valuesFromLoyaltyEnabled(loyaltyEnabled) {
  if (loyaltyEnabled) {
    return values;
  } else {
    return ["Documents"];
  }
}

function toString(value) {
  if (value === "Documents") {
    return "documents";
  } else {
    return "loyalty";
  }
}

function fromString(value) {
  switch (value) {
    case "documents" :
      return "Documents";
    case "loyalty" :
      return "Loyalty";
    default:
      return;
  }
}

function toLabel(value) {
  if (value === "Documents") {
    return I18n.t("Documents");
  } else {
    return I18n.t("Loyalty");
  }
}

let queryStringCodec = JsonCodec.object1(toString, value => {
  let tab = fromString(value);
  if (tab !== undefined) {
    return {
      TAG: "Ok",
      _0: tab
    };
  } else {
    return {
      TAG: "Error",
      _0: {
        NAME: "UnexpectedJsonValue",
        VAL: [
          [],
          value
        ]
      }
    };
  }
}, JsonCodec.field("tab", JsonCodec.string));

function encodeQueryString(value) {
  return QueryString.stringify(JsonCodec.encodeWith(value, queryStringCodec));
}

function decodeQueryString(query) {
  let tab = JsonCodec.decodeWith(QueryString.parse(query), queryStringCodec);
  if (tab.TAG === "Ok") {
    return tab._0;
  }
}

function useUrlState(loyaltyEnabled) {
  let match = Navigation.useUrl();
  let state = match.state;
  let pathname = match.pathname;
  let navigate = Navigation.useNavigate();
  let tab = Stdlib_Option.getOr(Stdlib_Option.filter(decodeQueryString(match.query), tab => valuesFromLoyaltyEnabled(loyaltyEnabled).includes(tab)), "Documents");
  let setTab = tab => {
    let route;
    route = tab === "Documents" ? pathname : pathname + "?" + QueryString.stringify(JsonCodec.encodeWith(tab, queryStringCodec));
    navigate({
      replace: true,
      state: state
    }, route);
  };
  return [
    tab,
    setTab
  ];
}

let Tab = {
  values: values,
  valuesFromLoyaltyEnabled: valuesFromLoyaltyEnabled,
  toString: toString,
  fromString: fromString,
  toLabel: toLabel,
  queryStringCodec: queryStringCodec,
  encodeQueryString: encodeQueryString,
  decodeQueryString: decodeQueryString,
  useUrlState: useUrlState
};

function CustomerDetailsPage$CustomerDetailsTabsCard(props) {
  let onTabChange = props.onTabChange;
  let tab = props.tab;
  let customer = props.customer;
  let hasEligibleReward = Stdlib_Option.mapOr(customer.loyalty, false, param => param.eligibleRewards.length !== 0);
  let tmp;
  tmp = tab === "Documents" ? JsxRuntime.jsx(CustomerDetailsPage$CustomerDetailsSaleDocumentsTabview, {
      customer: customer
    }) : JsxRuntime.jsx(CustomerDetailsLoyalty.Tabview.make, {
      customerId: customer.id,
      onRequestSubscribe: props.onRequestSubscribe,
      loyalty: customer.loyalty
    });
  let match = customer.loyalty;
  let tmp$1;
  tmp$1 = tab === "Documents" || match === undefined ? null : JsxRuntime.jsx(CanaryCard.make, {
      children: JsxRuntime.jsx(CustomerDetailsLoyalty.LoyaltyActions.make, {
        customerId: customer.id,
        shopId: customer.shop.id,
        currentPoints: match.stats.availablePoints
      })
    });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(CanaryCard.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsx(CategoryTablist.make, {
              items: valuesFromLoyaltyEnabled(props.loyaltyEnabled).map(value => ({
                key: toString(value),
                label: toLabel(value),
                statusLight: value === "Loyalty" && hasEligibleReward
              })),
              value: toString(tab),
              onChange: key => Stdlib_Option.forEach(fromString(key), onTabChange)
            }),
            tmp
          ],
          space: "none"
        }),
        stylex: {
          paddingTop: "2px"
        }
      }),
      tmp$1
    ]
  });
}

let CustomerDetailsTabsCard = {
  Tab: Tab,
  make: CustomerDetailsPage$CustomerDetailsTabsCard
};

function make$6(customer) {
  let status = Customer.Status.fromArchivedAt(customer.archivedAt);
  return {
    resourceName: customer.name,
    subtitle: Customer.Kind.toLabel(customer.isBusiness ? "Business" : "Individual"),
    subtitleBadgeElement: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Customer.Status.Badge.make, {
        value: status,
        archivedAt: customer.archivedAt
      }),
      spaceLeft: "xsmall"
    }),
    mainActionsElement: JsxRuntime.jsx(make$5, {
      id: customer.id,
      status: status
    })
  };
}

let CustomerDetailsHeader = {
  make: make$6
};

function CustomerDetailsPage$ViewPage(props) {
  let customer = props.customer;
  let loyaltyEnabled = !customer.isBusiness && Loyalty.useAddonActivated(customer.shop.id);
  let customer$1;
  if (loyaltyEnabled) {
    customer$1 = customer;
  } else {
    let newrecord = {...customer};
    newrecord.loyaltyUnsubscribedAt = undefined;
    newrecord.loyalty = undefined;
    newrecord.isLoyaltyMember = false;
    customer$1 = newrecord;
  }
  let match = useUrlState(loyaltyEnabled);
  let setTab = match[1];
  let match$1 = React.useState(() => false);
  let setSubscribeModalOpened = match$1[1];
  let onRequestSubscribe = () => {
    setTab("Loyalty");
    setSubscribeModalOpened(param => true);
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs(NextResourceDetailsPage.Column.make, {
        children: [
          JsxRuntime.jsx(make$3, {
            customer: customer$1
          }),
          loyaltyEnabled ? JsxRuntime.jsx(CustomerDetailsPage$CustomerDetailsLoyaltyCard, {
              customer: customer$1,
              onRequestOpenLoyaltyTab: () => setTab("Loyalty"),
              onRequestSubscribe: onRequestSubscribe
            }) : null,
          JsxRuntime.jsx(CustomerDetailsPage$CustomerDetailsAddressesCard, {
            customer: customer$1
          }),
          JsxRuntime.jsx(CustomerDetailsPage$CustomerDetailsMiscCard, {
            customer: customer$1
          }),
          JsxRuntime.jsx(CustomerDetailsPage$CustomerDetailsMetadataCard, {
            customer: customer$1
          })
        ]
      }),
      JsxRuntime.jsxs(NextResourceDetailsPage.Column.make, {
        children: [
          JsxRuntime.jsx(CustomerDetailsPage$CustomerDetailsTabsCard, {
            customer: customer$1,
            loyaltyEnabled: loyaltyEnabled,
            tab: match[0],
            onTabChange: setTab,
            onRequestSubscribe: onRequestSubscribe
          }),
          loyaltyEnabled ? JsxRuntime.jsx(CustomerDetailsLoyalty.LoyaltySubscribeModal.make, {
              customerId: customer$1.id,
              opened: match$1[0],
              onRequestClose: () => setSubscribeModalOpened(param => false)
            }) : null
        ]
      })
    ]
  });
}

let ViewPage = {
  make: CustomerDetailsPage$ViewPage
};

function useCustomerDetailsQueryAsyncResultFn(variables) {
  return ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, variables));
}

function CustomerDetailsPage(props) {
  let __useCustomerDetailsQueryAsyncResult = props.useCustomerDetailsQueryAsyncResult;
  let useCustomerDetailsQueryAsyncResult = __useCustomerDetailsQueryAsyncResult !== undefined ? __useCustomerDetailsQueryAsyncResult : useCustomerDetailsQueryAsyncResultFn;
  let customerData = AsyncResult.mapError(AsyncResult.mapOk(useCustomerDetailsQueryAsyncResult({
    customerId: props.id
  }), make), param => {});
  let tmp;
  let exit = 0;
  let customer;
  if (typeof customerData !== "object") {
    tmp = null;
  } else if (customerData.TAG === "Reloading") {
    let customer$1 = customerData._0;
    if (customer$1.TAG === "Ok") {
      customer = customer$1._0;
      exit = 1;
    } else {
      tmp = null;
    }
  } else {
    let customer$2 = customerData._0;
    if (customer$2.TAG === "Ok") {
      customer = customer$2._0;
      exit = 1;
    } else {
      tmp = null;
    }
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(CustomerDetailsPage$ViewPage, {
      customer: customer
    }, customer.id);
  }
  return JsxRuntime.jsx(NextResourceDetailsPage.make, {
    children: tmp,
    header: AsyncResult.mapOk(customerData, make$6),
    resourceTypeLabel: I18n.t("Customer"),
    loadingOperations: [query]
  });
}

let CustomerDetailsLoyaltyFragment;

let make$7 = CustomerDetailsPage;

export {
  trimOptionalString,
  useEditRouterOptions,
  CustomerDetailsLoyaltyFragment,
  CustomerDetailsQuery,
  CustomerDetailsData,
  formatPricelist,
  CustomerDetailsSaleDocumentsTabview,
  CustomerDetailsInformationCard,
  CustomerDetailsLoyaltyCard,
  CustomerDetailsAddressesCard,
  CustomerDetailsMiscCard,
  CustomerDetailsMetadataCard,
  CustomerDetailsPageActions,
  CustomerDetailsTabsCard,
  CustomerDetailsHeader,
  ViewPage,
  useCustomerDetailsQueryAsyncResultFn,
  make$7 as make,
}
/* query Not a pure module */
